import { render } from "./PrevNextDetail.vue?vue&type=template&id=5c92525b&scoped=true"
import script from "./PrevNextDetail.vue?vue&type=script&lang=js"
export * from "./PrevNextDetail.vue?vue&type=script&lang=js"

import "./PrevNextDetail.vue?vue&type=style&index=0&id=5c92525b&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c92525b"]])

export default __exports__